if (!customElements.get('jbhk-navigation')) {
  customElements.define('jbhk-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const searchToggle = this.querySelector('#JBHKLupe');
      const searchInput = this.querySelector('#JBHKSearch');
      const details = [...this.querySelectorAll('details')];
      const logo = this.querySelector('.jbhk-hd__logo');
      const navList = this.querySelector('.jb-desktop .jb-nav__list');
      const longPlaceholder = searchInput.placeholder;
      if (searchInput.dataset.short && matchMedia('(max-width: 749px)').matches) searchInput.placeholder = searchInput.dataset.short;
      // Desktop: widest bubble (max 600px) that still leaves the category nav fully visible once it has slid left,
      // nav keeping 24px to the logo and to the bubble. Too tight (< 280px): the logo fades (.is-eng) and the nav may take its place.
      const fit = () => {
        const items = navList?.children;
        if (!this.media.matches || !items?.length) return;
        const box = el => el.getBoundingClientRect();
        const slid = new DOMMatrixReadOnly(getComputedStyle(navList).transform).m41; // a slide may still be running
        const navLeft = box(items[0]).left - slid;
        const navRight = box(items[items.length - 1]).right - slid;
        const end = box(searchToggle).right - 24;
        const widthFor = left => Math.min(600, end - (navRight - (navLeft - left)));
        let width = widthFor(box(logo).right + 24);
        const tight = width < 280;
        if (tight) width = widthFor(box(logo).left);
        this.classList.toggle('is-eng', tight);
        this.style.setProperty('--jb-sw', `${width}px`);
        this.style.setProperty('--jb-nav-x', `${Math.min(0, end - width - navRight)}px`);
        // The long example text needs about 540px of bubble
        if (searchInput.dataset.short) searchInput.placeholder = width >= 540 ? longPlaceholder : searchInput.dataset.short;
      };
      const close = detail => {
        detail.open = false;
        detail.querySelector(':scope > summary').setAttribute('aria-expanded', 'false');
      };
      const setSearch = (open, focus = false) => {
        if (open) fit();
        this.classList.toggle('is-suche', open);
        searchToggle.setAttribute('aria-expanded', String(open));
        searchToggle.setAttribute('aria-label', searchToggle.dataset[open ? 'labelClose' : 'labelOpen']);
        if (focus) (open ? searchInput : searchToggle).focus({ preventScroll: true });
      };
      details.forEach(detail => {
        const summary = detail.querySelector(':scope > summary');
        summary.setAttribute('aria-expanded', String(detail.open));
        detail.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(detail.open));
          if (detail.open) {
            details.forEach(other => {
              if (other !== detail && !other.contains(detail) && !detail.contains(other)) close(other);
            });
            setSearch(false);
          }
        }, options);
      });
      searchToggle.addEventListener('click', event => {
        event.preventDefault(); // type=submit form=JBHKSuche only matters without JS (goes to /search)
        details.forEach(close);
        setSearch(!this.classList.contains('is-suche'), true);
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) {
          details.forEach(close);
          setSearch(false);
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) {
          details.forEach(close);
          setSearch(false);
        }
      }, options);
      // On document: Safari/Firefox do not focus a clicked <summary>, so focus may sit on <body>
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = (this.contains(event.target) && event.target.closest('details[open]')) || this.querySelector('details[open]');
        if (open) {
          event.preventDefault();
          close(open);
          open.querySelector(':scope > summary').focus();
        } else if (this.classList.contains('is-suche')) {
          event.preventDefault();
          setSearch(false, true);
        }
      }, options);
      // Arrow keys: ArrowDown on a dropdown button opens it and enters the list; Up/Down walk the links; Up on the first link returns to the button.
      this.addEventListener('keydown', event => {
        const dropdown = event.target.closest('.jb-nav__dropdown');
        if (!dropdown || !/^Arrow(Up|Down)$/.test(event.key)) return;
        event.preventDefault();
        const links = [...dropdown.querySelectorAll('.jb-nav__panel a')];
        if (event.target.tagName === 'SUMMARY') {
          if (event.key === 'ArrowDown') {
            dropdown.open = true;
            links[0]?.focus();
          }
          return;
        }
        const next = links[links.indexOf(event.target) + (event.key === 'ArrowDown' ? 1 : -1)];
        if (next) next.focus();
        else if (event.key === 'ArrowUp') dropdown.querySelector(':scope > summary').focus();
      }, options);
      this.querySelectorAll('.jb-nav a').forEach(link => {
        link.addEventListener('click', () => details.forEach(close), options);
      });
      addEventListener('resize', () => { if (this.classList.contains('is-suche')) fit(); }, options);
      this.media = matchMedia('(min-width: 1100px)');
      this.media.addEventListener('change', () => {
        details.forEach(close);
        setSearch(false);
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
